import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { btnVariant, btnSize } from './button'
import './styles.scss'

const Button = React.forwardRef(
    ({ active, children, disabled, variant, size, shape, block, className, loading, onClick = () => {}, ...props }, ref) => (
        <button
            ref={ref}
            className={classNames('btn', className, btnVariant[variant], btnSize[size], shape, {
                'btn-block': block,
                'btn--loading': loading,
            })}
            onClick={e => {
                if (active && !disabled) onClick(e)
            }}
            disabled={disabled || loading}
            {...props}
        >
            {children}
        </button>
    )
)

Button.defaultProps = {
    active: true,
    block: false,
    disabled: false,
    size: 'middle',
    loading: false,
    htmltype: 'button',
    variant: 'default',
    shape: 'round',
}

Button.propTypes = {
    active: PropTypes.bool,
    block: PropTypes.bool,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    children: PropTypes.node,
    htmltype: PropTypes.string,
    className: PropTypes.string,
    shape: PropTypes.oneOf(['round', 'circle']),
    size: PropTypes.oneOf(['small', 'middle', 'large']),
    variant: PropTypes.oneOf(['default', 'primary', 'secondary', 'disabled', 'stress', 'outlined']),
    onClick: PropTypes.func,
}

export default Button
